var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2H15.95C15.718 0.86 14.708 0 13.5 0H10.5C9.292 0 8.283 0.86 8.05 2H7.5C5.019 2 3 4.019 3 6.5V19.5C3 21.981 5.019 24 7.5 24H16.5C18.981 24 21 21.981 21 19.5V6.5C21 4.019 18.981 2 16.5 2ZM20 19.5C20 21.43 18.43 23 16.5 23H7.5C5.57 23 4 21.43 4 19.5V6.5C4 4.57 5.57 3 7.5 3H8.5C8.776 3 9 2.776 9 2.5C9 1.673 9.673 1 10.5 1H13.5C14.327 1 15 1.673 15 2.5C15 2.776 15.224 3 15.5 3H16.5C18.43 3 20 4.57 20 6.5V19.5ZM12 13C13.654 13 15 11.654 15 10C15 8.346 13.654 7 12 7C10.346 7 9 8.346 9 10C9 11.654 10.346 13 12 13ZM12 8C13.103 8 14 8.897 14 10C14 11.103 13.103 12 12 12C10.897 12 10 11.103 10 10C10 8.897 10.897 8 12 8ZM16.985 17.879C17.051 18.147 16.888 18.419 16.62 18.485C16.579 18.495 16.539 18.5 16.499 18.5C16.275 18.5 16.071 18.348 16.014 18.121C15.565 16.313 13.877 15 11.999 15C10.121 15 8.433 16.312 7.984 18.121C7.917 18.389 7.645 18.548 7.378 18.486C7.11 18.42 6.947 18.148 7.013 17.88C7.571 15.632 9.668 14.001 11.998 14.001C14.328 14.001 16.425 15.632 16.983 17.88L16.985 17.879Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8801f9725046c5b3df403dc186d65c69.svg";
export { ForwardRef as ReactComponent };